import React from 'react';
import { EyeIcon } from 'lucide-react';
export function UnderReviewBadge() {
  return <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-sm border border-[#F9C88C] bg-sf-amber-light px-1.5 text-[11px] font-semibold leading-[18px] text-sf-amber-text" data-id="element-913" data-mp="yyb227ijk5or">
      <EyeIcon className="h-3 w-3" aria-hidden="true" data-id="element-914" data-mp="p7gduxlqiw0o" />
      Under review
    </span>;
}